<template>
  <div style="padding-right: 2rem;">
    <!-- <policy-detail /> -->
    <!-- <task-detail @onSave="reloadAll" @onDelete="reloadAll" /> -->
    <task-detail />
    <!-- 
    <div class="d-flex align-items-center hand" @click="goBack()">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="38" viewBox="0 0 40 38" fill="none">
        <path d="M38.75 19.0003H1.25M1.25 19.0003L18.9583 1.29199M1.25 19.0003L18.9583 36.7087" stroke="#FF7C48" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <h4 class="ml-2 mt-2">{{ $t("task.plural") }}</h4>
    </div>
    <div class="d-flex justify-content-between mt-4" style="margin-bottom: 1.70rem;">
      <div class="d-flex align-items-center" style="gap: 2.34rem;">
        <div class="search2">
          <div class="search2--icon"><i class="iconoir-search"></i></div>
          <input class="search2--input" type="text" :placeholder="$t('task.search')" v-model="nameFilter" />
        </div>
      </div>
    </div> -->
    <div class="text-center">
      <h4>{{ $t("task.archived") }}</h4>
    </div>
    <div class="d-flex align-center hand" @click="goBack()">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="38" viewBox="0 0 40 38" fill="none">
        <path d="M38.75 19.0003H1.25M1.25 19.0003L18.9583 1.29199M1.25 19.0003L18.9583 36.7087" stroke="#FF7C48" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <h4 class="ml-2 mt-2">{{ $t("task.plural") }}</h4>
    </div>
    <div class="d-flex justify-content-start align-items-center w-100 mt-4" style=" gap:2.34rem;margin-bottom: 1.70rem;">
      <div>
        <select v-model="dateField" class="form-control">
          <option selected value="createdAt">{{ $t("common.created-at") }}</option>
          <option value="updatedAt">{{ $t("common.lastUpdateDate") }}</option>
          <option value="duedate">{{ $t("task.duedate") }}</option>
          <option value="donedate">{{ $t("task.donedate") }}</option>
        </select>
      </div>
      <div class="w-25">
        <date-picker v-model="rangeDate" range :placeholder="$t('common.date')" @change="setDateValue" :lang="currentLanguage"> </date-picker>
      </div>
      <div class="d-flex ml-auto">
        <b-dropdown v-if="isDownloadEnabled" split split-href="#" :text="$t('task.download-options')" size="sm" variant="light" class="m-2">
          <b-dropdown-item @click="downloadExcel" href="#">{{ $t("common.download") }}</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <nav class="tab-menu" v-if="scope !== 'ACCOUNT'">
      <div :class="{ active: activeTab === 'account' }" @click="activeTab = 'account'">{{ $t("task.my") }}</div>
      <div v-if="hasOrganizationTaskViewPermission" :class="{ active: activeTab === 'organization' }" @click="activeTab = 'organization'">
        {{ $t("task.organization") }}
      </div>
    </nav>

    <div class="tab-content">
      <div :class="{ active: activeTab === 'account' }">
        <!-- <content-loading v-if="isMyTasksLoading" /> -->
        <!-- <div v-else> -->
        <div>
          <list-view
            id="account"
            :scope="scope"
            :archived="true"
            :name="nameFilter"
            @nameFilter="nameFilter = $event"
            :no="noFilter"
            @noFilter="noFilter = $event"
            :description="descriptionFilter"
            @descriptionFilter="descriptionFilter = $event"
            :status="statusFilter"
            @statusFilter="statusFilter = $event"
            :organization="organizationFilter"
            @organizationFilter="organizationFilter = $event"
            :activeTab="activeTab"
          />

          <empty v-if="!myTasksPagination || myTasksPagination.docs.length == 0">
            <h5 class="text-center">
              {{ $t("common.no-data") }}
            </h5>
          </empty>

          <!-- Begin: Pagination -->

          <div v-if="myTasksPagination" class="row">
            <div class="col">
              <ul class="pagination pagination-rounded mb-0">
                <b-pagination
                  v-model="myTasksRequest.options.page"
                  :total-rows="myTasksPagination.totalDocs"
                  :per-page="myTasksPagination.limit"
                  limit="10"
                  size="sm"
                ></b-pagination>
              </ul>
            </div>
          </div>
          <!-- End: Pagination -->
        </div>
      </div>
      <div :class="{ active: activeTab === 'organization' }">
        <!-- <content-loading v-if="isOrganizationTasksLoading" /> -->
        <!-- <div v-else> -->
        <div>
          <list-view id:="organization" :scope="scope" :activeTab="activeTab" :name="nameFilter" @nameFilter="nameFilter = $event" @noFilter="noFilter =$event"
          :description="descriptionFilter" @descriptionFilter="descriptionFilter = $event" :status="statusFilter" @statusFilter="statusFilter = $event" :account="accountFilter"
          @accountFilter="accountFilter = $event" />

          <empty v-if="!organizationTasksPagination || organizationTasksPagination.docs.length == 0">
            <h5 class="text-center">
              {{ $t("common.no-data") }}
            </h5>
          </empty>

          <!-- Begin: Pagination -->

          <div v-if="organizationTasksPagination" class="row">
            <div class="col">
              <ul class="pagination pagination-rounded mb-0">
                <b-pagination
                  v-model="organizationTasksRequest.options.page"
                  :total-rows="organizationTasksPagination.totalDocs"
                  :per-page="organizationTasksPagination.limit"
                  limit="10"
                  size="sm"
                ></b-pagination>
              </ul>
            </div>
          </div>
          <!-- End: Pagination -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@modules/core/websocket";
import DatePicker from "vue2-datepicker";
// import PolicyDetail from "../policy/component/policy-detail";

import ListView from "./tasks-list-view.vue";

export default {
  props: ["scope"],
  components: {
    ListView,
    // PolicyDetail,
    DatePicker,
  },
  data() {
    return {
      organizationTasksRequest: {
        options: { page: 1, limit: 10, sort: { priority: "desc", no: "asc" } },
        query: { archived: { value: true, isObject: true } },
      },
      myTasksRequest: {
        options: { page: 1, limit: 10, sort: { priority: "desc", no: "asc" } },
        query: { archived: { value: true, isObject: true } },
      },
      nameFilter: undefined,

      noFilter: undefined,
      descriptionFilter: undefined,
      accountFilter: undefined,
      statusFilter: undefined,
      organizationFilter: undefined,
      dateField: "createdAt",
      activeTab: "account",
      rangeDate: [],
    };
  },

  computed: {
    hasOrganizationTaskViewPermission() {
      const permissions = [
        "ORGANIZATION_LEGAL_ADMIN",
        "ORGANIZATION_RISK_ADMIN",
        "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
        "ORGANIZATION_GDPR_PRODUCT_ADMIN",
        "ORGANIZATION_KVKK_PRODUCT_ADMIN",
        "ORGANIZATION_DDO_PRODUCT_ADMIN",
        "ORGANIZATION_BGYS_PRODUCT_ADMIN",
      ];

      if (this.currentAccountHasPermissions(permissions)) {
        return true;
      }

      return false;
    },
    isDownloadEnabled() {
      if (this.activeTab == "account") {
        return this.myTasksPagination && this.myTasksPagination.docs.length > 0;
      } else {
        return this.organizationTasksPagination && this.organizationTasksPagination.docs.length > 0;
      }
    },
    myTasks() {
      return this.myTasksPagination?.docs ?? [];
    },
    myTasksPagination() {
      return this.$store.getters["task/myTasksPagination"];
    },
    organizationTasks() {
      return this.organizationTasksPagination?.docs ?? [];
    },
    organizationTasksPagination() {
      return this.$store.getters["task/organizationTasksPagination"];
    },
    isOrganizationTasksLoading() {
      return this.$store.getters["task/isOrganizationTasksLoading"];
    },
    isMyTasksLoading() {
      return this.$store.getters["task/isMyTasksLoading"];
    },
  },

  watch: {
    dateField(n, o) {
      if ((n, n != o)) {
        this.clearDateFilter();
      }
    },
    organizationTasksRequest: {
      deep: true,
      immediate: true,
      handler() {
        this.debounceMixin(() => this.paginateOrganizationTasks(), "organization");
      },
    },

    myTasksRequest: {
      deep: true,
      immediate: true,
      handler() {
        this.debounceMixin(() => this.paginateMyTasks(), "my");
      },
    },
    nameFilter(n, o) {
      const localizedField = "name." + this.currentLanguage; //only for myTaskRequest
      if (n) {
        this.organizationTasksRequest.query = { ...this.organizationTasksRequest.query, name: { value: n } };

        this.myTasksRequest.query = { ...this.myTasksRequest.query, [localizedField]: { value: n } };
      } else {
        this.organizationTasksRequest.query["name"] = null;
        delete this.organizationTasksRequest.query["name"];

        this.myTasksRequest.query[localizedField] = null;
        delete this.myTasksRequest.query[localizedField];
      }
    },
    nameFilter(n, o) {
      const localizedField = "name." + this.currentLanguage; //only for myTaskRequest
      if (n) {
        this.organizationTasksRequest.query = { ...this.organizationTasksRequest.query, name: { value: n } };

        this.myTasksRequest.query = { ...this.myTasksRequest.query, [localizedField]: { value: n } };
      } else {
        this.organizationTasksRequest.query["name"] = null;
        delete this.organizationTasksRequest.query["name"];

        this.myTasksRequest.query[localizedField] = null;
        delete this.myTasksRequest.query[localizedField];
      }
    },
    noFilter(n, o) {
      if (n) {
        const isNumber = !isNaN(n);
        if (!isNumber) {
          this.clearNoFilter();
        }
        this.organizationTasksRequest.query = { ...this.organizationTasksRequest.query, ...(isNumber ? { no: { value: n, isObject: true } } : {}) };

        this.myTasksRequest.query = { ...this.myTasksRequest.query, ...(isNumber ? { no: { value: n, isObject: true } } : {}) };
      } else {
        this.clearNoFilter();
      }
    },

    descriptionFilter(n, o) {
      const localizedField = "description." + this.currentLanguage; //only for myTaskRequest
      if (n) {
        this.organizationTasksRequest.query = { ...this.organizationTasksRequest.query, description: { value: n } };

        this.myTasksRequest.query = { ...this.myTasksRequest.query, [localizedField]: { value: n } };
      } else {
        this.organizationTasksRequest.query["description"] = null;
        delete this.organizationTasksRequest.query["description"];

        this.myTasksRequest.query[localizedField] = null;
        delete this.myTasksRequest.query[localizedField];
      }
    },
    statusFilter(n, o) {
      if (n) {
        this.organizationTasksRequest.query = { ...this.organizationTasksRequest.query, status: { value: n, isObject: true } };

        this.myTasksRequest.query = { ...this.myTasksRequest.query, status: { value: n, isObject: true } };
      } else {
        this.organizationTasksRequest.query["status"] = null;
        delete this.organizationTasksRequest.query["status"];

        this.myTasksRequest.query["status"] = null;
        delete this.myTasksRequest.query["status"];
      }
    },
    organizationFilter(n, o) {
      if (n) {
        this.myTasksRequest.query = { ...this.myTasksRequest.query, organization: { value: n, isObject: true } };
      } else {
        this.myTasksRequest.query["organization"] = null;
        delete this.myTasksRequest.query["organization"];
      }
    },
    accountFilter: {
      deep: true,

      handler(n, o) {
        if (n) {
          this.organizationTasksRequest.query = { ...this.organizationTasksRequest.query, assignee: { value: n, isObject: true } };
        } else {
          this.organizationTasksRequest.query["assignee"] = null;
          delete this.organizationTasksRequest.query["assignee"];

          this.myTasksRequest.query["assignee"] = null;
          delete this.myTasksRequest.query["assignee"];
        }
      },
    },
  },
  mounted() {
    EventBus.$on("task-board-update", (e) => {
      this.reloadAll();
    });

    if (["GDPR", "KVKK", "DDO", "BGYS"].includes(this.scope)) {
      this.organizationTasksRequest = {
        ...this.organizationTasksRequest,
        query: { ...this.organizationTasksRequest.query, products: { value: this.scope, isObject: true } },
      };
      this.myTasksRequest = { ...this.myTasksRequest, query: { ...this.myTasksRequest.query, products: { value: this.scope, isObject: true } } };
    }

    this.$store.dispatch("organizationMember/paginateWith", { pagination: {}, organizationId: this.currentOrganization._id });
  },
  methods: {
    clearDateFilter() {
      this.organizationTasksRequest.query.createdAt = null;
      this.organizationTasksRequest.query.updatedAt = null;
      this.organizationTasksRequest.query.duedate = null;
      this.organizationTasksRequest.query.donedate = null;

      delete this.organizationTasksRequest.query.createdAt;
      delete this.organizationTasksRequest.query.updatedAt;
      delete this.organizationTasksRequest.query.duedate;
      delete this.organizationTasksRequest.query.donedate;
      this.rangeDate = [];
    },
    setDateValue(item) {
      this.rangeDate = item;

      if (item && item.length == 2 && !item.includes(null)) {
        const startTime = new Date(this.rangeDate[0]).setHours(0, 0, 0, 0);
        const endTime = new Date(this.rangeDate[1]).setHours(23, 59, 59, 999);

        this.organizationTasksRequest = {
          ...this.organizationTasksRequest,
          query: { ...this.organizationTasksRequest.query, [this.dateField]: { value: { $gte: startTime, $lte: endTime }, isObject: true } },
        };

        this.myTasksRequest = {
          ...this.myTasksRequest,
          query: { ...this.myTasksRequest.query, [this.dateField]: { value: { $gte: startTime, $lte: endTime }, isObject: true } },
        };
      } else {
        this.clearDateFilter();
      }
    },
    clearNoFilter() {
      this.organizationTasksRequest.query["no"] = null;
      delete this.organizationTasksRequest.query["no"];

      this.myTasksRequest.query["no"] = null;
      delete this.myTasksRequest.query["no"];
    },
    goBack() {
      if (!this.currentProduct || this.currentProduct == "PLATFORM") {
        window.history.back();
        return;
      }
      this.$router.push(`/${this.currentProduct.toLowerCase()}/tasks`);
    },
    async paginateOrganizationTasks() {
      if (!this.hasOrganizationTaskViewPermission) return;

      await this.$store.dispatch("task/fetchOrganizationArchivedTasks", this.organizationTasksRequest);
    },
    async paginateMyTasks() {
      let payload = {
        ...this.myTasksRequest,
        query: {
          ...this.myTasksRequest.query,
          organization: { value: this.currentOrganization?._id, isObject: true },
        },
      };
      if (this.scope === "ACCOUNT") {
        delete payload.query.organization;
      }

      await this.$store.dispatch("task/fetchCurrentUserAssignedArchivedTask", payload);
    },
    applyMemberFilter(member) {
      if (member.selected) {
        member.selected = false;
        this.organizationTasksRequest = {
          ...this.organizationTasksRequest,
          query: {
            ...this.organizationTasksRequest.query,
            assignee: undefined,
          },
        };
      } else {
        this.organizationMembers.forEach((i) => (i.selected = false));
        member.selected = true;
        this.organizationTasksRequest = {
          ...this.organizationTasksRequest,
          query: {
            ...this.organizationTasksRequest.query,
            assignee: { value: member.accountId, isObject: true },
          },
        };
      }
    },
    openNewTaskModal() {
      this.$store.commit("task/showTaskCreateModal", true);
    },

    reloadAll() {
      this.paginateMyTasks();
      this.paginateOrganizationTasks();
    },

    //
    async download(item) {
      this.$store.commit("fileManager/addDownloadedFile", { file: item });
    },

    async downloadExcel() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        const payload = { organization: { _id: this.currentOrganization?._id, name: this.currentOrganization?.name } };
        if (this.scope == "ACCOUNT" || this.scope == "ORGANIZATION") {
          payload.products = ["GDPR", "KVKK", "PLATFORM"];
        } else if (this.scope == "GDPR") {
          payload.products = ["GDPR"];
        } else if (this.scope == "KVKK") {
          payload.products = ["KVKK"];
        } else if (this.scope == "DDO") {
          payload.products = ["DDO"];
        } else if (this.scope == "BGYS") {
          payload.products = ["BGYS"];
        }

        if (this.scope == "ACCOUNT") {
          delete payload.organization;
        }
        if (this.activeTab == "account") {
          payload.downloadScope = this.scope == "ACCOUNT" ? "ACCOUNT" : "ACCOUNT_IN_ORGANIZATION";
        } else if (this.activeTab == "organization") {
          payload.downloadScope = "ORGANIZATION";
        }
        payload.archived = true;

        const { data: file } = await this.$store.dispatch(`task/download`, payload);
        this.download(file);

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        console.error(error);
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    ////
    onSelect() {
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./tasks";
</style>
